export const UPDATE_DATA = 'UPDATE_DATA';
export const UPDATE_SEARCH = 'UPDATE_SEARCH';
export const UPDATE_SORT = 'UPDATE_SORT';
export const UPDATE_STATUS_FILTER = 'UPDATE_STATUS_FILTER';
export const UPDATE_TYPE_FILTER = 'UPDATE_TYPE_FILTER';
export const UPDATE_ERROR_MESSAGE = 'UPDATE_ERROR_MESSAGE';
export const UPDATE_SCROLL_TO_INDEX = 'UPDATE_SCROLL_TO_INDEX';
export const SELECT_REQUEST = 'SELECT_REQUEST';
export const SET_TABLE_HEADER_WIDTH = 'SET_TABLE_HEADER_WIDTH';
export const FETCH_FILE = {
  REQUEST: 'FETCH_FILE_REQUEST',
  SUCCESS: 'FETCH_FILE_SUCCESS',
  FAILURE: 'FETCH_FILE_FAILURE',
};
export const RESET = 'RESET';
